import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { Card, CardBody, Input, Button } from 'reactstrap'
import DataTable from 'react-data-table-component'
import { getAllData, deleteIdData } from '../../lib/counselorcorner'
import { useRoleBasedUrl } from '../../Hooks/useRoleBasedUrl'

const GlobalCounselorCorner = ({ slug, isAdmin }) => {
	const [notes, setNotes] = useState([])
	const [showData, setShowData] = useState(false)
	const [namedNotes, setNamedNotes] = useState([])
	const [searchTerm, setSearchTerm] = useState('')
	const [loading, setLoading] = useState(false)
	const role = useRoleBasedUrl()

	const handleDelete = async (id) => {
		const choice = window.confirm('Are you sure you want to delete this note?')
		if (choice) {
			try {
				await deleteIdData(id)
				const updatedNotes = notes.filter((note) => note.id !== id)
				setNotes(updatedNotes)
				const updatedNamedNotes = namedNotes.filter((note) => note.id !== id)
				setNamedNotes(updatedNamedNotes)
			} catch (error) {
				console.error('Error deleting note:', error)
			}
		}
	}

	const fetchNotes = async () => {
		try {
			setLoading(true)
			const notesfromdb = await getAllData()
			console.log('Counselor corner data:', notesfromdb)
			const sortedNotesfromdb = [...notesfromdb].sort((a, b) => a.id - b.id)
			setNamedNotes(sortedNotesfromdb)
		} catch (error) {
			console.error('Error fetching notes:', error)
		} finally {
			setLoading(false)
		}
	}

	useEffect(() => {
		fetchNotes()
	}, [])

	const filteredNotes = namedNotes.filter((data) => {
		const searchData = searchTerm.toLowerCase()
		return (
			data.ndate?.toLowerCase().includes(searchData) ||
			data.instructorName?.toLowerCase().includes(searchData) ||
			data.studentName?.toLowerCase().includes(searchData) ||
			data.note?.toLowerCase().includes(searchData) ||
			data.name?.toLowerCase().includes(searchData) ||
			data.surname?.toLowerCase().includes(searchData)
		)
	})

	const noteColumns = [
		{
			name: 'Date',
			selector: (row) => row.ndate,
			sortable: true,
			center: true,
			width: '10%'
		},
		{
			name: 'Written By',
			selector: (row) => row.instructorName || `${row.name || ''} ${row.surname || ''}`,
			sortable: true,
			center: true,
			width: '15%'
		},
		{
			name: 'Student',
			selector: (row) => row.studentName,
			sortable: true,
			center: true,
			width: '15%'
		},
		{
			name: 'Note',
			selector: (row) => row.note,
			sortable: false,
			center: false,
			width: '35%',
			cell: (row) => <div style={{ maxWidth: '400px', wordWrap: 'break-word' }}>{row.note}</div>
		},
		{
			name: 'Actions',
			selector: (row) => row.actions,
			sortable: false,
			center: true,
			width: '35%',
			cell: (row) => (
				<div className="d-flex gap-2 justify-content-center">
					{isAdmin ? (
						<Link
							to={`${process.env.PUBLIC_URL}/${role}/class-management/counselor-corner/edit/${slug}/Update/${row.id}`}
							className="btn btn-success btn-sm"
						>
							Update
						</Link>
					) : (
						<Link
							to={`${process.env.PUBLIC_URL}/${role}/class-management/counselor-corner/edit/${slug}/Update/${row.id}`}
							className="btn btn-success btn-sm"
						>
							Update
						</Link>
					)}
					<button className="btn btn-danger btn-sm" onClick={() => handleDelete(row.id)}>
						Delete
					</button>
				</div>
			)
		}
	]

	const tableData = filteredNotes
		.filter((data) => isAdmin || data.instructorId === slug || data.subinstructorId === slug)
		.map((item) => ({
			...item,
			onDelete: handleDelete
		}))

	return (
		<Card>
			<CardBody>
				<div className="d-flex justify-content-between align-items-center mb-3">
					<h4 className="mb-0">{isAdmin ? 'Admin Private Notes' : 'Private Notes'}</h4>
					<div className="d-flex gap-2">
						<Button color="outline-info" onClick={() => setShowData(!showData)}>
							{showData ? 'Hide' : 'Show'}
						</Button>
						<Link to={`${process.env.PUBLIC_URL}/${role}/class-management/counselor-corner/edit/${slug}/Add/0`} className="btn btn-primary">
							<i className="fa fa-plus me-2"></i>
							Add New Note
						</Link>
					</div>
				</div>

				{showData && (
					<>
						<div className="mb-3">
							<Input type="text" placeholder="Search in private notes..." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
						</div>

						<div className="table-responsive">
							<DataTable
								columns={noteColumns}
								data={tableData}
								striped={true}
								center={true}
								pagination
								paginationServer
								progressPending={loading}
								highlightOnHover={true}
								responsive={true}
								noDataComponent="No notes found"
							/>
						</div>
					</>
				)}
			</CardBody>
		</Card>
	)
}

export { GlobalCounselorCorner }
